import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import BookingPage from "@/pages/BookingPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import PackagesPage from "@/pages/PackagesPage";
import BoatPage from "@/pages/BoatPage";
import MotorcyclePage from "@/pages/MotorcyclePage";
import RvPage from "@/pages/RvPage";
import GiftsPage from "@/pages/GiftsPage";
import GalleryPage from "@/pages/GalleryPage";
import SchedulePage from "@/pages/SchedulePage";
import AboutPage from "@/pages/AboutPage";
import DealsPage from "@/pages/DealsPage";
import AdminSignup from "@/pages/AdminSignup";
import ContactPage from "@/pages/ContactPage";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/book" element={<BookingPage />} />
            <Route path="/schedule" element={<SchedulePage />} />
            <Route path="/packages" element={<PackagesPage />} />
            <Route path="/boat-detailing-packages" element={<BoatPage />} />
            <Route path="/motorcycle-detailing-packages" element={<MotorcyclePage />} />
            <Route path="/rv-detailing-packages" element={<RvPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/gifts" element={<GiftsPage />} />
            <Route path="/about-us" element={<AboutPage />} />
            <Route path="/deals" element={<DealsPage />} />
            <Route path="/join" element={<AdminSignup />} />
            <Route path="/owner-login" element={<AdminSignup />} />
            <Route path="/contact-us" element={<ContactPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
